























import { Produto, ProdutosService } from "@/services/produtos.service";
import { Component, Vue } from "vue-property-decorator";
import FormProduto from "./FormProduto.vue";
import TabelaItemKit from "./kit/TabelaItemKit.vue";
import Loading from "@/shared/components/loading.vue";
import dayjs from "dayjs";

@Component({
  components: {
    FormProduto,
    TabelaItemKit,
    Loading,
  },
})
export default class AlterarPreco extends Vue {
  loading = false;
  produto: Produto | null = null;

  mounted() {
    this.fetchProduto();
  }

  get idProduto() {
    return this.$route.params.id;
  }

  get idCatalogo() {
    return this.$route.params.idCatalogo;
  }

  async fetchProduto() {
    this.loading = true;
    this.produto = await ProdutosService.obterProduto(this.idProduto);
    this.produto.validoApos = dayjs().startOf("month").format("YYYY-MM-DD");
    this.loading = false;
  }
  routeBack() {
    this.$router.back();
  }
}
